import { Check } from "lucide-react";

export const FeaturesSection = ({ features }: { features: any[] }) => {
    if (!features || features.length === 0) return null;

    return (
        <div className="py-12 px-4 container mx-auto">
            <h2 className="text-3xl font-bold text-center mb-8">المميزات</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                {features.map((feature, idx) => (
                    <div key={idx} className="p-6 bg-white rounded-lg shadow-sm border text-center">
                        <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                            <Check className="h-6 w-6 text-primary" />
                        </div>
                        <h3 className="font-bold text-xl mb-2">{feature.title}</h3>
                        <p className="text-gray-600">{feature.description}</p>
                    </div>
                ))}
            </div>
        </div>
    );
};
